import React from "react"
import Highcharts from "highcharts"
import HighchartsReact from "highcharts-react-official"
import withSize from "react-sizeme"
import PropTypes from "prop-types"
import { highchartsColors } from 'Constants'

// changed tooltip to include point name

import css from "./BaseChart.module.css";
void css;

class BaseChart extends React.Component {
  static propTypes = {
    decimals: PropTypes.number,
    colors: PropTypes.arrayOf(PropTypes.string)
  }

  static defaultProps = {
    decimals: 2,
    colors: highchartsColors
  }

  componentDidUpdate({ size: { height, width } }) {
    if (
      (width !== this.props.width || height !== this.props.height) &&
      this.refs.highchart &&
      this.refs.highchart.chart
    ) {
      this.refs.highchart.chart.reflow();
    }
  }

  render() {
    let { options, decimals, colors } = this.props;
    // TODO ... for some reason, colors exists in props and is undefined. Fix this so 
    // we can use defaultProps rather than ternary operator in colors. There, we should just
    // have "colors,", not "colors: colors?colors:highchartsColors,"
/*    console.log("Base hasowncolors [%O]",this.props.hasOwnProperty("colors"));
    console.log("Base colors [%O]",this.props.colors);
    console.log("Base props [%O]",this.props);
    console.log("Constants Colors [%O]",highchartsColors);*/
    return (
      <HighchartsReact
        ref="highchart"
        highcharts={Highcharts}
        options={{
          ...options,
          colors: colors ? colors : highchartsColors,
          chart: {
            reflow: false,
            ...options.chart,
            spacingBottom: 0,
            spacingTop: 5,
            spacingRight: 0,
            spacingLeft: 0
          },
          credits: { enabled: false },
          tooltip: {
pointFormat: `<br/><span style="color: {point.color} ">\u25CF</span> {point.series.name} {point.name}: {point.y:.${decimals}f}`
          },
          time: {
            useUTC: true
          }
        }}
      />
    );
  }
}

export default withSize()(BaseChart);
